import { twMerge } from 'tailwind-merge';
import CompliancePill from '@/components/ui/CompliancePill';
import { actionPriorityLabel, actionPriorityRating } from '../actionPriority';
import type { ActionPriority } from '../types';

export default function ActionPriorityPill({
  priority,
  className
}: {
  priority: ActionPriority | null | undefined;
  className?: string;
}) {
  if (!priority) {
    return <span className={twMerge('text-xs text-content-subtlest italic', className)}>No priority</span>;
  }
  return (
    <CompliancePill text={actionPriorityLabel(priority)} stop={actionPriorityRating(priority)} className={className} />
  );
}
